<template>
  <div class="pl-2"
    >
    <div class="mr-2 mt-2 d-flex">
      <div>New Ending: @</div>
      <input
        class="company-mail-endings-details-input"
        ref="bemail-input"
        v-model="new_ending"
        >
    </div>
    <v-btn
      class="mt-2"
      color="green"
      :disabled="is_submit_disabled"
      @click="createUObject({
        url: [
          {businesses: business.id},
          {bemails: ''},
          {showWithEntitiesNormalized: ''}
        ],
        u_object: {
          value: new_ending
        },
        resp_data: {
          bemails: [
            {value: new_ending}
          ]
        }
        }).then(() => {
          new_ending = ''
          })"
      >
      submit
    </v-btn>
    <div v-if="is_submit_disabled">error: {{is_submit_disabled}}</div>
  </div>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex';
  export default {
    props: [],
    data: () => ({
      new_ending: ''
    }),
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects',
      ]),
      business() {
        let current_user = this.$store.getters['Auth/getUser'];
        return this.$store.state.Ultra.businesses[current_user.business.id];
      },
      is_submit_disabled() {
        if (this.new_ending === '') {
          return 'string is empty!';
        } else {
          let endings = this.getUObjects({type: 'bemails', ids: this.business.bemails});
          if (endings.filter(ending => ending.value === this.new_ending).length !== 0) {
            return 'ending already exists';
          } else {
            return false;
          }
        }
      }
    },
    methods: {
      ...mapActions('Ultra', [
        'createUObject',
      ]),
    }
  }
</script>
<style>
  .class {
  }
</style>
